import { useCallback, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessTracker } from './trackerModel';
import { trackerCoachRequest } from './trackerCoachClient';

const empty = { data: null, loading: true, refreshing: false, error: '' };
export default function useTrackerCoach(paperId) {
    const { user, userData } = useAuth();
    const allowed = canAccessTracker(userData, paperId), key = `${user?.uid}:${paperId}:${allowed}`;
    const [state, setState] = useState(empty);
    const reloadRef = useRef(() => {});
    useEffect(() => {
        let active = true, busy = false, lastRefresh = 0;
        setState({ ...empty, key });
        if (!user?.uid || !allowed) { setState({ ...empty, key, loading: false, error: 'This tracker is not available to your account.' }); return; }
        const refresh = async () => {
            if (!active || busy) return;
            busy = true; lastRefresh = Date.now(); setState(previous => ({ ...previous, refreshing: true }));
            try {
                const data = await trackerCoachRequest('load', { paperId });
                if (active) setState({ key, data, loading: false, refreshing: false, error: '' });
            } catch (error) {
                if (active) setState(previous => ({ ...previous, key, loading: false, refreshing: false, error: 'Study planning could not refresh. Check your connection and retry.' }));
            } finally { busy = false; }
        };
        reloadRef.current = refresh; refresh();
        const focus = () => { if (document.visibilityState !== 'hidden' && Date.now() - lastRefresh >= 30000) refresh(); };
        const timer = setInterval(focus, 300000);
        window.addEventListener('focus', focus); window.addEventListener('online', focus);
        return () => { active = false; clearInterval(timer); window.removeEventListener('focus', focus); window.removeEventListener('online', focus); };
    }, [user?.uid, paperId, allowed, key]);
    return { ...(state.key === key ? state : empty), reload: useCallback(() => reloadRef.current(), []) };
}
